import React, { useState } from "react";
import i18n from "i18next";

// Fabric Imports
import { Text } from "@fluentui/react-components";

import "./Academy.scss";

import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import useWindowSize from "../../helpers/useWindowSize";

function AcademyContentEN(props: { name: string }) {
  const windowSize = useWindowSize();

  return (
    <div className="lueb-ContentBlock">
      <div style={{ marginTop: 20 }}>
        {props.name == "LSP3APPLICATIONWORKSHOP" && (
          <div>
            <h3>FIND OUT WHAT IS IMPORTANT IN CASE IT IS GETTING TIGHT.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>Introduction to the LSP3 product portfolio</li>
                    <div className="lueb-listNormal">
                      <ul>
                        <li>Different designs (standard/inline)</li>
                        <li>Open and closed geared offset heads</li>
                        <li>Supplementary components for fastening systems</li>
                        <li>Product properties</li>
                      </ul>
                    </div>
                    <li>LSP3 fastening systems: use and application areas</li>
                    <li>
                      Accessibility investigations with the LSP3 Projecting Set/
                      3D data
                    </li>
                    <li>
                      Opportunities and advantages of the LÜBBERING DIGITAL
                      online platform
                    </li>
                    <li>
                      How to configure LSP3 fastening systems in the LSP3
                      configurator
                    </li>
                    <li>Avoiding errors when projecting</li>
                    <li>Overview of special solutions</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (incl. catering)</div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div>1,5 to 2 days</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 6</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    With the largest range of standardised geared offset heads
                    in the world, LÜBBERING can offer you solutions for
                    practically any fastening application. We will give you an
                    overview of our entire range of LÜBBERING standard geared
                    offset heads, angle heads and nuts. We will show you how to
                    choose from the enormous range of possibilities to put
                    together the fastening system that matches your requirements
                    exactly. Get to know the modularity of our L.SP3 product
                    world and become an expert.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    We will show you which opportunities and advantages you can
                    have by using our online platform LÜBBERING DIGITAL. For
                    instance, you will have access to L.SP3 Configurator or to
                    L.SP3 Quick Finder, a quick search module for fastening
                    system components. In addition, you can centrally administer
                    your fastening systems across a team. In our workshop, you
                    will receive all the important information that are
                    necessary for your application. Besides that, you will be
                    shown how mistakes during project planning can be avoided
                    and how you can do feasibility tests with our L.SP3
                    Projecting sets.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: participants will be able to use the LSP3
                    projecting set and our LSP3 configurator confidently. This
                    will ensure quick and accurate selection of the optimal LSP3
                    fastening system.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LSP3INSTALLATIONWORKSHOP" && (
          <div>
            <h3>THE RIGHT APPROACH TO THE RIGHT ADJUSTMENT.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>The structure of LSP3 fastening systems</li>
                    <li>Commissioning fastening systems</li>
                    <li>Confident handling of fastening systems</li>
                    <li>Operating the L.SP3 fastening system</li>
                    <li>Avoiding operating errors</li>
                    <li>Performing basic maintenance</li>
                    <li>
                      Identifying, analysing and correcting technical problems
                    </li>
                    <li>
                      Options and advantages of using the LÜBBERING DIGITAL
                      online platform.
                    </li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING Academy or on site at your company </div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div>5 hours</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 6</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    The L.SP3 Installation Workshop focusses on the needs of
                    technical staff who are responsible for commissioning tools
                    in automotive or aerospace plants. In this workshop, our
                    experts will train you in how to adapt LÜBBERING fastening
                    systems to your tools. You will also gain useful knowledge
                    about safety and commissioning L.SP3 fastening systems.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    We will show you how to perform basic maintenance tasks on
                    your fastening system in order to ensure a long lifetime for
                    your L.SP3 product. The workshop will also train you to
                    identify and analyse technical problems and show you how to
                    correct them yourself.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    The LÜBBERING DIGITAL online platform offers you the
                    possibility of viewing the technical product data of your
                    L.SP3 products at any time. Once you have registered your
                    fastening system, LÜBBERING DIGITAL will recommend
                    preventative maintenance tasks and calculate lubrication
                    cycles. We will demonstrate how this works in this workshop.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: If you wish to adapt and commission your LSP3
                    fastening system yourself, then safety and functionality are
                    prime considerations. In this workshop, we will pass on to
                    you our expertise in commissioning, maintenance and problem
                    solving.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LSP3OPERATORWORKSHOP" && (
          <div>
            <h3>BECOME AN EXPERT IN USING YOUR FASTENING SYSTEM.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>Confident handling of L.SP3 fastening systems</li>
                    <li>Using a fastening system</li>
                    <li>Avoiding operating errors</li>
                    <li>Performing basic maintenance</li>
                    <li>Identifying technical problems</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING Academy or on site at your company </div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div>3 hours</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 6</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    In the L.SP3 Operator Workshop, users of LÜBBERING fastening
                    systems will learn everything they need to know about the
                    optimal handling of the tools they use. Our experts will
                    demonstrate how to avoid or preempt, technical problems and
                    explain how to resolve any issues.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    You will receive first hand expertise in optimal operation
                    and handling. You can look forward to competent trainers
                    with years of product knowledge, who will help you to get
                    the most out of your fastening system. Our aim is for you to
                    use your fastening system correctly and with confidence and
                    so to maximise the lifetime of your tool.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: Learn everything about the optimal operation
                    and handling of your L.SP3 fastening systems in the L.SP3
                    Operator Workshop.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LSP3MAINTENANCEWORKSHOP" && (
          <div>
            <h3>BENEFIT FROM THE CONSTANT USE OF YOUR FASTENING SYSTEMS.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>The structure of LSP3 fastening systems</li>
                    <li>Confident handling of fastening systems</li>
                    <li>Dismantling fastening systems</li>
                    <li>Identifying and analysing faulty or worn components</li>
                    <li>
                      Trouble-shooting and performing complex maintenance tasks
                    </li>
                    <li>Reassembling fastening systems</li>
                    <li>Recommissioning fastening systems</li>
                    <li>Introduction to special solutions</li>
                    <li>
                      Opportunities and advantages of the LÜBBERING DIGITAL
                      online platform
                    </li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>

              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING Academy</div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div>1 day</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 4</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Reliable fastening in the tightest of spaces needs geared
                    offset heads with consistent efficiency and ultra-high
                    precision. In these situations, it is imperative to know
                    when wearing parts need to be replaced and what must be
                    considered when removing and assembling the L.SP3 systems.
                    The correct maintenance of LÜBBERING geared offset heads can
                    extend the shelf life far beyond the guarantee period.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Let our high quality standards inspire you. In our L.SP3
                    Maintenance Workshop, you will find out all about the
                    structure of the L.SP3 fastening systems, how to dismantle
                    and reassemble correctly and then to recommission your
                    fastening system. In addition, we will present the
                    possibilities and advantages of our online platform and will
                    also demonstrate practical applications.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: You will optimise the lifetime of your L.SP3
                    fastening system by knowing when to replace wear parts and
                    what is important when dismantling and assembling. Learn how
                    to perform maintenance and service tasks independently and
                    competently.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "CUSTOMIZEDWORKSHOP" && (
          <div>
            <h3>TAILORED TO YOUR INDIVIDUAL DEMANDS.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>The structure of your LSP3 special fastening system</li>
                    <li>Confident handling of your special fastening system</li>
                    <li>
                      Commissioning and operating your special fastening system
                    </li>
                    <li>Avoiding operating errors</li>
                    <li>Dismantling your special fastening system</li>
                    <li>Identifying and analysing faulty or worn components</li>
                    <li>
                      Trouble-shooting and performing essential maintenance
                      tasks
                    </li>
                    <li>Assembling your special fastening system</li>
                    <li>Recommissioning</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING ACADEMY (incl. catering)</div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div>1 to 2 days</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 4</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Every day, LÜBBERING deals with cases where poor
                    accessibility to fastenings and complex assembly processes
                    with stringent quality requirements are a challenge. Our
                    expert team of developers and design engineers is well
                    qualified to work out solutions for you, even in fastening
                    applications where access seems impossible.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Learn all about the structure of your L.SP3 special
                    fastening system and how to handle it with confidence.
                    Starting with the commissioning and operation of your L.SP3
                    system, to the assembly and dismantling. You will be
                    equipped for any eventuality.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    In the Customised Workshop, we will show you how to identify
                    faulty and worn components when dismantling your system and
                    how to correct technical problems. Regular maintenance is
                    necessary for smooth and long-term use of your special
                    fastening system. Make use of our expertise to maximise the
                    lifetime of your fastening system and gain a unique insight
                    into further LÜBBERING special solutions.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: You will receive information on the operation,
                    maintenance and error correction that is specifically
                    tailored to your special fastening system.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
      </div>

      <div style={{ marginTop: 20 }}>
        {props.name == "LADUAPPLICATIONWORKSHOP" && (
          <div>
            <h3>NOT ALL DRILLING IS THE SAME. FIND OUT WHAT IS IMPORTANT.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li> Introduction to the L.ADU product portfolio</li>
                    <div className="lueb-listNormal">
                      <ul>
                        <li>Various types of machines</li>
                        <li>L.ADU electronic and L.ADU pneumatic</li>
                        <li>L.ADU locking systems</li>
                        <li>Supplementary components for drilling systems</li>
                        <li>Product features</li>
                      </ul>
                    </div>
                    <li>L.ADU: use and application areas</li>
                    <li>Accessibility investigations</li>
                    <li>Avoiding errors when projecting</li>
                    <li>Overview of special solutions</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING ACADEMY (incl. catering)</div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div>1 days</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 6</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    Not all drilling is the same: Drills and conditions in pro
                    duction plants regularly pose new challenges when selecting
                    the right machine configuration.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    Our L.ADU Application Workshop provides a different
                    perspective on processes and helps you to understand what
                    options are available in finding the optimal solution to a
                    highly specialised application. We have years of experience
                    in solving problems in drilling technology.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    What is the right machine type for my application? Which
                    machine configuration should I choose for my combination of
                    materials? These and many other questions concern our
                    customers when they are planning an LÜBBERING Advanced
                    Drilling Unit. The L.ADU Application Workshop will help you
                    to choose the right tool for your application. Our experts
                    will be happy to explain to you what options are available
                    to optimise your drilling process and so increase your
                    productivity. With this workshop, we give you a glimpse into
                    the development and functional capabilities of our
                    high-precision tools for drilling technology. Discover the
                    individually configurable pneumatic and electronic drilling
                    units and be impressed by the precision, ergonomic design
                    and versatility of the L.ADU product series. At the same
                    time, use our expertise from countless examples of drilling
                    technology – and find out how to choose the optimum
                    combination of drive machine, interlocking system and
                    optional components for your drilling application.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: You will get to know out complete L.ADU
                    product portfolio and so be able to find the optimal L.ADU
                    for your application as quickly as possible. Make use of our
                    expertise to optimise your application.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUINSTALLATIONWORKSHOP" && (
          <div>
            <h3>THE RIGHT APPROACH TO THE RIGHT ADJUSTMENT.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>The structure of an L.ADU</li>
                    <li>Commissioning drilling systems</li>
                    <li>Software functions of L.ADU electronic</li>
                    <li>Avoiding operating errors</li>
                    <li>Performing basic maintenance</li>
                    <li>Confident handling of drilling systems</li>
                    <li>Operating an L.ADU</li>
                    <li>Identifying and analysing technical problems</li>
                    <li>Correcting technical problems</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING Academy or on site at your company</div>

                  <div>
                    <u>Duration:</u>
                  </div>
                  <div> 5 hours</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 6</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    As with many things, the case with drilling technology
                    solutions is that a drilling machine will only drill as well
                    as it has been set up. In our L.ADU Installation Workshop,
                    we will show you how to set up your L.ADU pneumatic or L.ADU
                    electronic drilling machine correctly.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    There are many things to consider when using complex
                    drilling machines. In the Installation Workshop you will
                    learn how to use an electronic or a pneumatic L.ADU safely.
                    You will also discover how to avoid operator errors and how
                    to identify technical problems on the drilling machine. In
                    order to ensure constant and optimal drilling quality,
                    adjustments and minor maintenance work on your L.ADU are
                    necessary. After this workshop, you will be able to this
                    competently by yourself. You can look forward to a lot of
                    new information that you will be able to make use of
                    straightaway.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: f you wish to commission your L.ADU electronic
                    or L.ADU pneumatic yourself, then safety and functionality
                    are prime considerations. In this workshop, we will pass on
                    to you our expertise in commissioning, maintenance and error
                    prevention.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUOPERATORWORKSHOP" && (
          <div>
            <h3>SO THAT YOU AND YOUR MACHINE ARE PERFECTLY MATCHED.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li> Confident handling of drilling systems</li>
                    <li>Operating an L.ADU</li>
                    <li>Avoiding operating errors</li>
                    <li>Identifying technical problems</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div> LÜBBERING Academy or on site at your company</div>

                  <div>
                    <u>Duration:</u>
                  </div>
                  <div> 3 hours</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 6</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    The L.ADU Operator Workshop is aimed at you, as the user of
                    a pneumatic or electronic LÜBBERING Advanced Drilling Unit
                    and will show you how to best use your L.ADU pneumatic or
                    L.ADU electronic drilling machine in aircraft production.
                    You will learn everything about the operation of the machine
                    and will receive useful tips about handling it from our
                    drilling technology experts.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    The issues of safety and troubleshooting are also important
                    points on the workshop agenda. We want you to feel
                    completely confident when performing a drilling process, to
                    be able to identify faults at an early stage and to be able
                    to repair them yourself.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: Learn everything about the optimal and
                    confident operation of an L.ADU electronic or L.ADU
                    pneumatic drilling machine and benefit from the constant use
                    of your drilling machine.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUMAINTENANCEWORKSHOP" && (
          <div>
            <h3>
              OUR SPECIALISTS WILL SHOW YOU HOW YOU CAN BECOME A SPECIALIST.
            </h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>The structure of an L.ADU</li>
                    <li>Confident handling of drilling systems</li>
                    <li>Dismantling drilling systems</li>
                    <li>Identifying and analysing faulty or worn components</li>
                    <li>Overview of special solutions</li>
                    <li>
                      Trouble-shooting and performing complex maintenance task
                    </li>
                    <li>Repair and reassembly of an L.ADU </li>
                    <li>Recommissioning an L.ADU</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (incl. catering)</div>

                  <div>
                    <u>Duration:</u>
                  </div>
                  <div> 1 to 2 days</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 4</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    L.ADU is the name we have given to our high performance
                    machines, which can alter entire manufacturing strategies
                    and significantly increase productivity. They are able to
                    perform complex motion sequences at extremely high speeds
                    and simultaneously make precise drillings. In order to
                    ensure long-term availability, our L.ADU Maintenance
                    Workshop will show you in detail how to operate the L.ADU
                    for maximum performance and long life. Improve the life time
                    of your L.ADU with our help.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    The focus of this workshop is the professional maintenance
                    and independent repair of our products. In particular,
                    direct contact with our drilling technology experts gives
                    users the opportunity to clarify all questions immediately.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    With training that is tailored to the drilling machine that
                    you use, you will be trained to perform repairs and
                    maintenance work on your electronic and pneumatic drilling
                    machines correctly by yourself. Thus, service life and
                    durability of your L.ADU will be significantly increased.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: You will optimise the lifetime of your L.ADU
                    electronic or L.ADU pneumatic by knowing when to replace
                    wear parts and what is important when dismantling and
                    assembling. Learn how to perform maintenance and service
                    tasks independently and competently.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
        {props.name == "LADUPROGRAMMINGWORKSHOP" && (
          <div>
            <h3>GET TO KNOW THE DIGITAL WORLD OF DRILLING.</h3>
            <StackShim
              horizontal
              tokens={{ childrenGap: 10 }}
              wrap={true}
              horizontalAlign={
                windowSize.width > 1024 ? "space-between" : "start"
              }
            >
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Contents</h4>
                  <ul>
                    <li>The structure of an L.ADU</li>
                    <li>Confident handling of your L.ADU electronic</li>
                    <li>Presentation of the L.ADU smart interface</li>
                    <li>Programming your L.ADU electronic</li>
                    <li>Commissioning your L.ADU electronic</li>
                    <li>Avoiding operating errors</li>
                    <li>Correcting technical problems</li>
                    <li>Examples of applications</li>
                  </ul>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <h4>Organisation</h4>
                <div>
                  <div>
                    <u>Venue:</u>
                  </div>
                  <div>LÜBBERING ACADEMY (incl. catering)</div>
                  <div>
                    <u>Duration:</u>
                  </div>
                  <div> 1 to 2 days</div>

                  <div>
                    <u>Number of participants:</u>
                  </div>
                  <div>1 to 4</div>

                  <div>
                    <u>Languages:</u>
                  </div>
                  <div>German &amp; English</div>
                </div>
              </StackItemShim>
              <StackItemShim
                grow={1}
                style={{ backgroundColor: " #faf9f8", padding: 20 }}
              >
                <div className="lueb-listWithPlusIcon">
                  <h4>Beschreibung</h4>
                  <div style={{ marginTop: 10 }}></div>
                  <Text>
                    The L.ADU Programming Workshop will show you the optimal
                    setting of the drilling process parameters of your
                    electronic drilling machine L.ADU electronic.
                  </Text>
                  <br></br>
                  <br></br>
                  <Text>
                    You will get to know all the functions of the L.ADU smart
                    interface software and will then be able to reprogram your
                    drill feed unit by yourself should changing parameters and
                    conditions require it. In addition, you will learn
                    everything about the digitisation of your drilling processes
                    and you will be able to exchange information directly with
                    our experts wherever you are. For example, by asking
                    questions about the representations of the graphics and
                    tables within the software. With this technical knowledge,
                    you will be able to shorten the duration of drilling cycles
                    significantly and to optimise your drilling processes
                    efficiently.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    This workshop takes place in our drilling technology
                    laboratories. Here, we have the opportunity to demonstrate
                    actual drillings under realistic conditions, using various
                    types of material stacks and drills. Take part in the L.ADU
                    Programming Workshop and experience with us the digital
                    world of drilling.
                  </Text>
                  <br></br>
                  <br></br>

                  <Text>
                    Your benefit: You will optimize your drilling processes and
                    work more efficiently. You will receive information tailored
                    to your needs for the optimal programming of your L.ADU
                    electronic and you will learn to programme it yourself.
                  </Text>
                </div>
              </StackItemShim>
            </StackShim>
          </div>
        )}
      </div>
    </div>
  );
}

export default AcademyContentEN;
